import { getLiteral } from 'utils/getLiteral';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import { PAGINATION_TABLE_ENTITY } from 'constants/Environment';

/** Pinned in the quick filter bar only (not duplicated in the drawer). */
const DEFAULT_QUICK_FILTER_IDS = ['status', 'dateCreation', 'dateLaunch'];

/** Shown in the filter drawer/sidebar by default, not pinned as quick filters. */
const SIDEBAR_DEFAULT_FILTER_IDS = ['updatedUser', 'createdUser', 'dateModification'];

const ALL_FILTER_IDS = [...DEFAULT_QUICK_FILTER_IDS, ...SIDEBAR_DEFAULT_FILTER_IDS];

export default (params) => ({
    pageSize: PAGINATION_TABLE_ENTITY,
    entity: CAMPAIGNS_MARKETING,
    selectionFor: 'marketingCampaigns',
    quickFilters: DEFAULT_QUICK_FILTER_IDS,
    defaultFilters: ALL_FILTER_IDS,
    filtersAddButtonSchema: [
        {
            label: getLiteral('action_filters'),
            options: ALL_FILTER_IDS,
        },
    ],
    useFiltersDrawer: true,
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('label_emails'),
            field: 'id',
            headerComponent: 'headerTextCell',
            headerComponentParams: {
                showTotal: true,
            },
            cellRenderer: 'marketingCampaignRow',
            minWidth: 1000,
            resizable: false,
            sortable: false,
            suppressMovable: true,
            lockPosition: true,
        },
    ],
});
